module.exports = __webpack_public_path__ + "img/1525010436.cb72f098.jpg";